import { BASEURL } from "../../API/apiData";
import {bmcListsRoutes, bmcMainRoutes} from "./routes"

const getAllKeyRevenueStreams = async (projectID , bmcID) => {
  const token = localStorage.getItem("token");

    const requestOptions = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        },
    };
    const response = await fetch(
        `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.revenue}`,
        requestOptions
      );
      const results = await response.json();
      return results;
}

const createNewKeyRevenueStreams = async (projectID, projectName, bmcID) => {
  const token = localStorage.getItem("token");

    const data = {
      revenue_stream_name: `${projectName} Key Revenue streams`
    }
    const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
    const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.revenue}`,
    requestOptions
    );
    const results = await response.json();
    return results;
} 

// === LIST ITEMS ===
const createNewKeyRevenueStreamsList = async (projectID, bmcID, channelID, name ) => {
  const token = localStorage.getItem("token");

  const data = {
    revenue_stream_item: {
      item_name: name
    }
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.revenue}/${channelID}/${bmcListsRoutes.revenueItems}`,
    requestOptions
    );

const results = await response.json();
return results;

}

const editNewKeyRevenueStreamsList = async (projectID, bmcID, channelID, name, ID ) => {
  const token = localStorage.getItem("token");

const data = {
  revenue_stream_item: {
    item_name: name
  }
}

const requestOptions = {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(data),
};

const response = await fetch(
  `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.revenue}/${channelID}/${bmcListsRoutes.revenueItems}/${ID}`,
  requestOptions
  );

const results = await response.json();
return results;

}

export { getAllKeyRevenueStreams , createNewKeyRevenueStreams, createNewKeyRevenueStreamsList, editNewKeyRevenueStreamsList }